import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import deepmerge from 'deepmerge';
import _ from 'lodash';

window.Vue = Vue;
Vue.use(VueRouter);

window.axios = axios;
window.deepmerge = deepmerge;

require('./utils/global-components');


// WEBPACK FOOTER //
// ./src/bootstrap.js